import {
  AnyRouteRefParams,
  RouteFunc,
  RouteRef,
  SubRouteRef,
  useRouteRef,
} from '@backstage/frontend-plugin-api';

/**
 * Resolves one of the announcements plugin's own routes.
 *
 * Unlike `useRouteRef` this never returns `undefined`: the plugin's routes are
 * always mounted when the plugin is installed, so a missing route is a setup
 * error and throws, like the legacy `useRouteRef` did.
 */
export function useAnnouncementsRoute<TParams extends AnyRouteRefParams>(
  routeRef: RouteRef<TParams> | SubRouteRef<TParams>,
): RouteFunc<TParams> {
  const routeFunc = useRouteRef(routeRef);
  if (!routeFunc) {
    throw new Error(`No path for ${routeRef}`);
  }
  return routeFunc;
}
